import { defineComponent as _defineComponent } from 'vue'
import { TUITranslateService } from "@tencentcloud/chat-uikit-engine";
import { ref, computed } from "../../../../../adapter-vue";
import { CHAT_MSG_CUSTOM_TYPE } from "../../../../../constant";
import { JSONToObject, isUrl } from "../../../../../utils/index";
import Icon from "../../../../common/Icon.vue";
import star from "../../../../../assets/icon/star-light.png";

export default /*#__PURE__*/_defineComponent({
  __name: 'message-abstract-custom',
  props: {
  contentText: {
    type: Array,
    default: [],
  },
  message: {
    type: Object,
    default: () => ({}),
  },
  messageContent: {
    type: Object,
    default: () => ({}),
  },
},
  setup(__props) {

const props = __props



const custom = ref<{ data?: String; description?: String; extension?: String }>(
  props?.message?.payload
);
const extensionJSON = computed(() => JSONToObject(custom?.value?.data));
const businessID = computed(() => extensionJSON?.value?.businessID);
const descriptionForShow = ref<Array<{ text: string; isHighlight: boolean }>>(props?.contentText);
const defaultMessageContent = ref<string>(props?.messageContent?.custom || "[自定义消息]")

return { __sfc: true,props, custom, extensionJSON, businessID, descriptionForShow, defaultMessageContent, TUITranslateService, CHAT_MSG_CUSTOM_TYPE, isUrl, Icon, star }
}

})